module.exports = __webpack_public_path__ + "assets/img/add.7a4a0bea.png";